module.exports = __webpack_public_path__ + "static/media/ICN_Gallery.84604b1c.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/ICN_Gallery.svg
// module id = 165
// module chunks = 0